import React, { useState } from "react";
import { useHistory } from "react-router-dom";

function ContactPage() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [result, setResult] = useState("");
  const history = useHistory();
  const publicUrl = process.env.PUBLIC_URL + "/";

  const validateForm = () => {
	let errors = {};
	let isValid = true;
  
	if (!/^[A-Za-z ]{3,}$/.test(name)) {
	  errors.name = "Name must be at least 3 letters long.";
	  isValid = false;
	}
  
	if (!/^\S+@\S+\.\S+$/.test(email)) {
	  errors.email = "Enter a valid email address.";
	  isValid = false;
	}
  
	if (!/^\d{10}$/.test(phone)) {
	  errors.phone = "Phone must be exactly 10 digits.";
	  isValid = false;
	}
  
	if (location.trim().length < 3) {
	  errors.location = "Location must be at least 3 characters.";
	  isValid = false;
	}
  
	if (message.trim().length < 10) {
	  errors.message = "Message must be at least 10 characters.";
	  isValid = false;
	}
  
	setErrors(errors);
	return isValid;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("location", location);
    formData.append("message", message);

    try {
      const response = await fetch("https://mieteducation.in/server/contact-mail.php", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      const data = await response.json();
      setResult(data.message);

      if (data.status === "success") {
        setName("");
        setEmail("");
        setPhone("");
        setLocation("");
        setMessage("");
        setErrors({});
        history.push("/thank-you");
      }
    } catch (error) {
      history.push("/thank-you");
    }
  };

  return (
    <div style={{ marginTop: "25px" }}>

		
      {/* Contact Form Section */}
      <div className="counter-area pd-bottom-120">
        <div className="container">
          <h2 className="title">Write to us</h2>
          <form className="contact-form-inner mt-5" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-6">
                <div className="single-input-inner style-bg-border">
                  <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                  {errors.name && <p className="error-text" style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errors.name}</p>}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="single-input-inner style-bg-border">
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {errors.email && <p className="error-text" style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errors.email}</p>}
                </div>
              </div>
              <div className="col-6">
                <div className="single-input-inner style-bg-border">
				<input
  type="tel"
  placeholder="Phone"
  value={phone}
  onChange={(e) => {
    // Allow only numbers
    const sanitizedValue = e.target.value.replace(/\D/g, "");
    setPhone(sanitizedValue);
  }}
  pattern="[0-9]{10}"
  maxLength="10"
  required
/>
{errors.phone && <p className="error-text" style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errors.phone}</p>}

                </div>
              </div>
              <div className="col-6">
              <div className="single-input-inner style-bg-border">
  <input
    type="text"
    placeholder="Location"
    value={location}
    onChange={(e) => {
      const value = e.target.value;
      // Allow only letters and spaces
      if (/^[a-zA-Z\s]*$/.test(value)) {
        setLocation(value);
      }
    }}
    required
  />
  {errors.location && (
    <p className="error-text" style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
      {errors.location}
    </p>
  )}
</div>

              </div>
              <div className="col-12">
                <div className="single-input-inner style-bg-border">
                  <textarea
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  />
                  {errors.message && <p className="error-text" style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>{errors.message}</p>}
                </div>
              </div>
              <div className="col-12">
                <button className="btn btn-base">Send Message</button>
              </div>
            </div>
          </form>
          {result && <p className="response-message">{result}</p>}
        </div>
      </div>

      {/* Contact Information */}
      <div className="contact-list pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4">
              <div className="contact-list-inner">
                <div className="media">
                  <div className="media-left">
                    <img src={publicUrl + "assets/img/icon/17.png"} alt="Phone Icon" />
                  </div>
                  <div className="media-body align-self-center">
                    <h5>Phone</h5>
                    
  <a href="tel:+919962924444">+91 9962924444</a> <br></br>  
  <a href="tel:+919962126120">+91 9962126120</a>   
  


                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-list-inner">
                <div className="media">
                  <div className="media-left">
                    <img src={publicUrl + "assets/img/icon/16.png"} alt="Address Icon" />
                  </div>
                  <div className="media-body align-self-center">
                    <h5>Address</h5>
                    <p>
  <b>MIET</b>, No. 385, Arcot Road, <br />
  Adj. Liberty Flyover, Kodambakkam, <br />
  Chennai - 600024. <br />
  <a 
    href="https://maps.app.goo.gl/XWtKotPrFwyBkGBA8" 
    target="_blank" 
    rel="noopener noreferrer"
    style={{ color: 'blue' }}
  >
    View on Google Maps
  </a>
</p>


                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-list-inner">
                <div className="media">
                  <div className="media-left">
                    <img src={publicUrl + "assets/img/icon/18.png"} alt="Email Icon" />
                  </div>
                  <div className="media-body align-self-center">
                    <h5>Email</h5>
                    <p><a href="mailto:tmgunaraja@gmail.com">tmgunaraja@gmail.com</a></p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     {/* Google Maps Section */}
	 <div className="contact-g-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d793.8190741028972!2d80.23044559064863!3d13.054238234918914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267db6fe15caf%3A0x4d4292162d38e1aa!2sMIET%20CHENNAI!5e0!3m2!1sen!2sin!4v1664346820511!5m2!1sen!2sin"
         
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default ContactPage;
